import request from '@/utils/request'

export function getBlogByLevel(params) {
  return request({
    url: process.env.WEB_API + '/index/getArticleByLevel',
    method: 'get',
    params
  })
}
export function getRedirect(params) {
  return request({
    url: process.env.WEB_API + '/redirect',
    method: 'get',
    params
  })
}
export function advertGetListByLevel(params) {
  return request({
    url: process.env.WEB_API + '/advert/getListByLevel',
    method: 'get',
    params
  })
}
export function advertClick(params) {
  return request({
    url: process.env.WEB_API + '/advert/click',
    method: 'get',
    params
  })
}

export function getNewBlog(params) {
  return request({
    url: process.env.WEB_API + '/index/getNewArticle',
    method: 'get',
    params
  })
}

export function getBlogByTime(params) {
  return request({
    url: process.env.WEB_API + '/index/getArticleByTime',
    method: 'get',
    params
  })
}

export function getHotBlog(params) {
  return request({
    url: process.env.WEB_API + '/index/getHotArticle',
    method: 'get',
    params
  })
}

export function getHotTag(params) {
  return request({
    url: process.env.WEB_API + '/index/getHotTag',
    method: 'get',
    params
  })
}

export function getLink(params) {
  return request({
    url: process.env.WEB_API + '/index/getLink',
    method: 'get',
    params
  })
}

export function addLinkCount(params) {
  return request({
    url: process.env.WEB_API + '/index/addLinkCount',
    method: 'get',
    params
  })
}

export function getWebConfig(params) {
  return request({
    url: process.env.WEB_API + '/index/getWebConfig',
    method: 'get',
    params
  })
}

export function getWebNavbar(params) {
  return request({
    url: process.env.WEB_API + '/index/getWebNavbar',
    method: 'get',
    params
  })
}

export function recorderVisitPage(params) {
  return request({
    url: process.env.WEB_API + '/index/recorderVisitPage',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/index.js